var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastPuff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2639_5525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.26112 13.5753C1.23531 13.9532 1.23531 14.3085 1.26112 14.6864C1.3352 15.7705 2.27449 16.5698 3.35966 16.6255C7.42755 16.8344 11.8015 16.7967 15.7589 16.5125V11.7493C11.8015 11.4651 7.42755 11.4274 3.35966 11.6363C2.27449 11.692 1.3352 12.4913 1.26112 13.5753Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9503 16.7067C13.2458 16.666 14.5225 16.6013 15.7587 16.5125V11.7493C14.5225 11.6605 13.2458 11.5958 11.9503 11.5551C11.7744 13.2821 11.7744 14.9798 11.9503 16.7067Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2047 1.24179C18.1199 3.63578 14.2895 4.59338 16.2047 6.98737",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7896 1.24179C14.7048 3.63578 10.8744 4.59338 12.7896 6.98737",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2639_5525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastPuff);
export default __webpack_public_path__ + "static/media/last_puff.e801e79413575263a4e17e39e0e7289c.svg";
export { ForwardRef as ReactComponent };